export const formattedOffsetMap = {
  '-10': '(UTC -10:00) Hawaii Time (US and Canada)',
  '-5': '(UTC -05:00) Eastern Time (US and Canada)',
  '-6': '(UTC -06:00) Central Time (US and Canada)',
  '-7': '(UTC -07:00) Mountain Time (US and Canada)',
  '-8': '(UTC -08:00) Pacific Time (US and Canada)',
  '-9': '(UTC -09:00) Alaska Time (US and Canada)',
};

const standardOffsetMap = {
  '-10': 'Pacific/Honolulu',
  '-5': 'America/New_York',
  '-6': 'America/Chicago',
  '-7': 'America/Denver',
  '-8': 'America/Los_Angeles',
  '-9': 'America/Anchorage',
};

// For use in react-select dropdown
// [{ label: '(UTC -05:00) Eastern Time (US and Canada)', value: '-5'}]
export const timezoneOptions = Object.entries(formattedOffsetMap).map(
  ([key, value]) => ({
    label: value,
    value: key,
  }),
);

export const getTimezone = (offset, map = standardOffsetMap) => {
  const defaultTimezone =
    Intl?.DateTimeFormat()?.resolvedOptions()?.timeZone ?? map['-5'];
  if (!offset || typeof offset !== 'string') return defaultTimezone;
  return map[offset] || defaultTimezone;
};

export const getFormattedTimezone = (offset) =>
  getTimezone(offset, formattedOffsetMap);

export default getTimezone;
